/*
 * @Author: 赵大壮 372839241@qq.com
 * @Date: 2026-02-24 11:15:35
 * @LastEditors: 赵大壮 372839241@qq.com
 * @LastEditTime: 2026-03-15 23:38:59
 * @FilePath: \利享乡村管理后台\src\views\用户管理\view\政企用户\Index.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import { Component, Vue, Inject } from "vue-property-decorator";
import DZUserService from "@/views/登录/service/DZUserService";
import DZServiceNormalUser from "@/views/用户管理/service/DZServiceNormalUser";
import ny_config from "@/api/nyConfig";
import api from "@/api/nyApiJson";
import DZSearchUser from "@/views/用户管理/model/DZSearchUser";
import DZModelZQUser from "../../model/DZModelZQUser";
import nyMessageToast from "@/utils/NYMessageToast";
import DZModelNormalUser from "../../model/DZModelNormalUser";

@Component({
    components: {}
})
export default class Index extends Vue {

    excelName = '用户列表'

    is_dialog_show = false

    is_dialog_show_update = false

    m_zq_user = new DZModelZQUser();

    json_fields = {
        '姓名': 'name',
        '手机': 'phone',
        '邮箱': 'email',
        '微信': 'wxNum',
        '地址': 'address',
        '状态': 'status'
    }

    toPrint() {
        this.$nyPrint.printTable(this.selections, this.json_fields, this.excelName)
    }

    $refs: any;

    table_height = 0;

    s_service = new DZServiceNormalUser();

    // 手机号正则
    phoneReg = /^1[3-9]\d{9}$/

    //审核状态：0-正常，1禁用
    bindStatus(n) {
        if (n === 0) {
            return '正常'
        } else if (n === 1) {
            return '禁用'
        } else {
            return n
        }
    }

    created() {
        this.action_list_data()
    }

    mounted() {
        this.$nextTick(() => {
            const mainHeight = this.$refs.mainContent.offsetHeight;
            console.log("mainHeight", mainHeight)
            const mainScreen = this.$refs.mainScreen.offsetHeight;
            console.log("mainScreen", mainScreen)
            this.table_height = mainHeight - mainScreen - 50;
        })
    }

    action_list_data() {
        this.s_service.net_zquser_list()
    }
    clean() {
        this.s_service.m_page = new DZSearchUser(10);
        this.action_list_data()
    }

    action_operate_user(id) {
        if (id) {
            this.s_service.net_operate_user(id, this.action_list_data)
        }
    }

    handleSizeChange(val) {
        this.s_service.m_page.pageSize = val
        this.action_list_data()
    }

    selections = []
    handleSelectionChange(val) {
        let arr = JSON.parse(JSON.stringify(val))
        arr.map(a => {
            a.status = this.bindStatus(a.status)
        })
        this.selections = arr;
    }

    dialog_close() {
        this.is_dialog_show = false
        this.is_dialog_show_update = false
        this.dialog_init()
        this.s_service.m_user = new DZModelNormalUser();
    }

    dialog_init() {
        this.m_zq_user.init();
    }

    action_add_user() {

        if (this.m_zq_user.phone.nyIsEmpty()) {
            nyMessageToast.warning("请输入手机号")
            return
        }
        if (!this.phoneReg.test(this.m_zq_user.phone)) {
            nyMessageToast.warning("请输入正确手机号")
            return
        }
        if (this.m_zq_user.password.length < 6) {
            nyMessageToast.warning("请校验密码")
            return
        }
        if (this.m_zq_user.password.nyIsEmpty()) {
            nyMessageToast.warning("请输入密码")
            return
        }
        if (this.m_zq_user.password != this.m_zq_user.password2) {
            nyMessageToast.warning("请确认密码")
            return
        }
        if (this.m_zq_user.name.nyIsEmpty()) {
            nyMessageToast.warning("请输入姓名")
            return
        }
        if (this.m_zq_user.governmentName.nyIsEmpty()) {
            nyMessageToast.warning("请输入单位名")
            return
        }
        this.s_service.net_add_zq_user(this.m_zq_user, () => {
            this.action_list_data()
            this.is_dialog_show = false
        })
    }

    action_edit_user() {
        if (this.m_zq_user.password) {
            if (this.m_zq_user.password.length < 6) {
                nyMessageToast.warning("请校验密码")
                return
            }
            if (this.m_zq_user.password != this.m_zq_user.password2) {
                nyMessageToast.warning("请确认密码")
                return
            }
        }
        this.s_service.net_edit_zq_user(this.m_zq_user, () => {
            this.action_list_data()
            this.is_dialog_show_update = false
        })
    }

    action_edit_data(item) {
        console.log("编辑数据：", item)
        this.m_zq_user.init();
        this.m_zq_user.id = item.accountId;
        this.m_zq_user.phone = item.phone;
        this.m_zq_user.password = item.password;
        this.m_zq_user.password2 = item.password2;
        this.m_zq_user.name = item.name;
        this.m_zq_user.governmentName = item.address;
        this.is_dialog_show_update = true;
    }
}
